var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.666 11.917C14.5635 11.917 15.291 11.1895 15.291 10.292C15.291 9.39453 14.5635 8.66699 13.666 8.66699C12.7686 8.66699 12.041 9.39453 12.041 10.292C12.041 11.1895 12.7686 11.917 13.666 11.917Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 2.16699C11.3831 2.16688 9.19169 3.06806 7.56885 4.67468C5.946 6.2813 5.02284 8.4635 5 10.747C5 16.6837 12.6375 23.292 12.9625 23.5737C13.1587 23.7415 13.4085 23.8337 13.6667 23.8337C13.9249 23.8337 14.1746 23.7415 14.3708 23.5737C14.75 23.292 22.3333 16.6837 22.3333 10.747C22.3105 8.4635 21.3873 6.2813 19.7645 4.67468C18.1416 3.06806 15.9503 2.16688 13.6667 2.16699ZM13.6667 14.0837C12.9167 14.0837 12.1837 13.8613 11.5601 13.4446C10.9366 13.028 10.4506 12.4358 10.1636 11.743C9.87664 11.0502 9.80155 10.2878 9.94786 9.55227C10.0942 8.81676 10.4553 8.14115 10.9856 7.61088C11.5158 7.08061 12.1914 6.71948 12.9269 6.57318C13.6625 6.42688 14.4248 6.50197 15.1177 6.78895C15.8105 7.07593 16.4027 7.56192 16.8193 8.18546C17.236 8.80899 17.4583 9.54207 17.4583 10.292C17.4583 11.2976 17.0589 12.262 16.3478 12.9731C15.6367 13.6842 14.6723 14.0837 13.6667 14.0837Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.60de4e662951ae6047782df38d246199.svg";
export { ForwardRef as ReactComponent };